/* eslint-disable no-alert */

angular.module('storefrontApp')
    .controller('emailSubscriptionController', [
        '$scope',
        'rsEmailSubscriptionService',
        function (
            $scope,
            rsEmailSubscriptionService,
        ) {
            $scope.firstName = '';
            $scope.lastName = '';
            $scope.email = '';
            $scope.errorMessage = '';
            $scope.errorCode = '';

            $scope.setSubscribe = function (source, successCallback) {
                if (!$scope.email || $scope.email === '') {
                    alert('Enter correct email');
                    return;
                }

                if ($scope.customer && $scope.customer.isRegisteredUser) {
                    $scope.firstName = $scope.customer.firstName;
                    $scope.lastName = $scope.customer.lastName;
                }

                rsEmailSubscriptionService.subscribe({
                    source,
                    firstName: $scope.firstName,
                    lastName: $scope.lastName,
                    email: $scope.email,
                })
                    .then((response) => {
                        if (response.data.statusCode !== 200) {
                            $scope.errorCode = response.data.statusCode;
                            $scope.errorMessage = response.data.reasonPhrase;
                            alert('Error ' + $scope.errorCode + ': ' + $scope.errorMessage);
                        } else {
                            alert('You have successfully subscribed to our newsletter!');
                            if (successCallback) {
                                successCallback();
                            }
                        }
                    });
            };
        }]);
